import React from 'react';
import PropTypes from 'prop-types';

import { withBrand } from '../../../../providers/BrandProvider';

import './PersonContentTable.scss';

export function PersonContentTable(props) {
  const { header, brand = {}, children } = props;

  return (
    <div className="person-content-table">
      {header && (
        <h2
          className="person-content-table__header"
          style={{
            color: brand.secondaryColor,
            borderColor: brand.primaryColor,
          }}
        >
          {header}
        </h2>
      )}
      {children}
    </div>
  );
}

PersonContentTable.propTypes = {
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  brand: PropTypes.object,
  children: PropTypes.node,
};

export default withBrand(PersonContentTable);
